module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "课程相关"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(this.result.courseSummary)
    }
  })])])]), _vm._v(" "), _c('div', [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-631433be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Myrecord/AboutCourse.vue
// module id = 781
// module chunks = 1